module.exports = __webpack_public_path__ + "img/3_01.581c1b42.jpg";